import { TranslationMap } from '@trimble-gcs/i18n-types';

export function scan3dRgbTranslations() {
  return {
    blendIntensity: {
      text: $localize`:@@scan3dRgb.blendIntensity:Blend Intensity`,
      desc: 'Label for the switch to show the point cloud with intensity coloring.',
      limit: 30,
    },
  } satisfies TranslationMap;
}
